import { generateEntityCrudReducer } from 'syft-acp-util/store/reducers'
import { CsatEmployerEntity } from './types'
import csatEmployerTypes from './action-types'

export default generateEntityCrudReducer<CsatEmployerEntity>({
  name: 'csatEmployers',
  actions: csatEmployerTypes,
})
